import { render, staticRenderFns } from "./statusBar.vue?vue&type=template&id=0f007582&"
import script from "./statusBar.vue?vue&type=script&lang=js&"
export * from "./statusBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports